// Find which stage1 category and sub-stage contains the action
export function findActionPath(action, schema) {
    // Search stage1 options (Solo, Classic, Fetish)
    for (let i = 0; i < schema.stage1.options.length; i++) {
        const category = schema.stage1.options[i];
        const nextStageName = category.next;
        const nextStage = schema[nextStageName];
        console.log("SEARCH", schema.stage1)
        // Search options in the category stage
        for (let j = 0; j < nextStage.options.length; j++) {
            const opt = nextStage.options[j];
            console.log("NEXT", opt)
            if (opt.data?.action === action) {
                return {
                    stage1Index: i,
                    stage1Next: nextStageName,
                    actionIndex: j,
                    actionNext: opt.next  // e.g., "stage_ethnicity_reverse_cowgirl"
                };
            }
        }
    }
    return null;
}